export enum PLAYER {
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=112146767 */
    TITLE = 'PLAY.VIDEO_PLAYER_TITLE',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=273002248 */
    WATCH_VIDEO = 'PLAY.WATCH_VIDEO',
}
